export default {
  meta: {
    title: '付款详情'
  }
};
